import { processesRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useEnableProcess = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    processesRepo.enableProcess(id),
  );
